<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useI18n } from 'vue-i18n';
const props = defineProps({
    articles:{
        type: Array,
        required: true
    },
    selectedArticle:{
        type: Object,
        required: true
    },
    productName:{
        type: String,
        required: true
    }
})
const emits = defineEmits(['selectArticle'])
const show_options = ref(false)
const selectRef = ref(null)
const { t, locale } = useI18n()

function availabilityText(article){
    if(article.available){
        return t('product.delivery24')
    }
    // we replace in article.delai {{between}} , {{and}}, {{days}}
    const delai = article.delai.replace(/{{between}}/g, t('product.between')).replace(/{{and}}/g, t('product.and')).replace(/{{days}}/g, t('product.days'))
    return delai
}

function handleClickOutside(event: MouseEvent) {
    if (show_options.value && selectRef.value && !selectRef.value.contains(event.target as Node)) {
        console.log('event target', event.target)
        show_options.value = false;
    }
}
function switch_select(event){
    event.stopPropagation()
    show_options.value = !show_options.value
}
function noClose(event) {
    event.stopPropagation()
}
function selectArticle(article){
    emits('selectArticle', article)
    show_options.value = false
}
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
})
onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})
</script>
<template>
    <div class="the_select" @click="switch_select">
        {{ props.selectedArticle.name }}
        <div class="the_select_options" ref="selectRef" v-if="show_options" @click="noClose">
            <table>
                <thead>
                    <tr>
                        <th>{{ $t('product.version') }}</th>
                        <th>{{ $t('product.price') }}</th>
                        <th>{{ $t('product.availability') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="article in props.articles" :key="article.id" @click="selectArticle(article.name)">
                        <td><b>{{ article.name }}</b></td>
                        <td><span v-if="article.prices.official > article.prices.discount" class="price_official">{{ article.prices.official.toFixed(2).replace('.','.') }}</span> {{ article.prices.discount.toFixed(2).replace('.',',') }} €</td>
                        <td :class="article.available? 'available':'unavailable'">{{ availabilityText(article) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style lang="scss" scoped> 
.the_select{
    margin-top: 5px;
    color: #000;
    background-color: #FFF;
    border-radius: 16px;
    padding: 3px 20px 5px 10px;
    position: relative;
    cursor: pointer;
    transition: all 0.3s;
    &:after{
        content: '';
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #000;
    }
    &:hover{
        background-color: #b6b6b6;
    }
    .the_select_options{
        position: absolute;
        left: 0;
        top: 100%;
        background-color: #FFF;
        max-width: calc(100vw - 20px);
        border-radius: 16px;
        box-shadow: 0 0 15px rgba(0,0,0,0.8);
        padding: 5px;
        z-index: 1000;
        table{
            width: 100%;
            td{
                
                white-space: nowrap;
                text-align: right;
                padding: 5px;
                border-bottom: 1px solid #0000002b;
                border-right: 1px solid #0000002b;
                .price_official{
                    text-decoration: line-through;
                    
                }
                &:last-child{
                    border-right: none;
                }
            }
            tbody{
                tr{
                    cursor: pointer;
                    transition: all 0.3s;
                    &:hover{
                        background-color: #0000002b;
                    }
                    td.available{
                        color: #03a703;
                    }
                    td.unavailable{
                        color: #d03232;
                    }
                    &:last-child{
                        td{
                            border-bottom: none;
                        }
                    }
                }
            }
        }
    }
}
</style>